import React, {useEffect, useState} from 'react';
import {v4 as uuidv4} from 'uuid';
import {defaultErrorHandler} from '../../../context/context';
import AddButton from '../../../libs/react-components-admin/buttons/add-button';
import DeleteButton from '../../../libs/react-components-admin/buttons/delete-button';
import CloseModal from '../../../libs/react-components-admin/modal/close-modal';
import ActionButton from '../../../libs/react-components-admin/buttons/action-button';
import MetafieldMapping from './metafield-mapping';

const MetafieldMappings = ({isSubIntegration, grantedAccessScopes, sourceFields, initialModel, onChange}) => {

  const [model, setModel] = useState((initialModel || {}).metafields || []);
  const [_sourceFields, setSourceFields] = useState(sourceFields);
  const [modalIndex, setModalIndex] = useState();

  useEffect(() => {
    onChange(isModelValid(model) ? {metafields: model} : null);
  }, [model]);
  useEffect(() => { setSourceFields(sourceFields); }, [sourceFields]);

  useEffect(() => {
    if (modalIndex != null && modalIndex < model.length) {
      CloseModal.showModal(
        <MetafieldMapping isSubIntegration={isSubIntegration}
                          grantedAccessScopes={grantedAccessScopes}
                          sourceFields={_sourceFields}
                          initialModel={model[modalIndex]}
                          onChange={v => setModel(model.map(m => m.id === v.id ? v : m))}/>,
        'modal-lg'
      );
      setModalIndex(null);
    }
  }, [modalIndex]);

  const isModelValid = m => m.length > 0 && m.every(({namespace, key, owner, valueMapping}) =>
    namespace && key && (isSubIntegration || (owner && owner.idMapping)) && valueMapping
  );

  const addMetafieldMapping = () => {
    const newModel = [...model, {id: uuidv4(), type: 'single_line_text_field'}];
    setModel(newModel);
    setModalIndex(newModel.length - 1);
    return Promise.resolve(null);
  };

  const deleteMetafieldMapping = id => {
    setModel(model.filter(m => m.id !== id));
    return Promise.resolve(null);
  };

  return <ul className="list-group">
    {model.map((mapping, i) => <li key={mapping.id} className="list-group-item">
      <div className="row align-items-center">
        <div className="col">
          {mapping.name}
        </div>
        <div className="col-auto">
          <ActionButton className="btn-sm btn-primary px-4"
                        action={() => {
                          setModalIndex(i);
                          return Promise.resolve(null);
                        }}
                        errorHandler={defaultErrorHandler}>
            Edit
          </ActionButton>
        </div>
        <div className="col-auto">
          <DeleteButton action={() => deleteMetafieldMapping(mapping.id)}
                        errorHandler={defaultErrorHandler}/>
        </div>
      </div>
    </li>)}
    <li className="list-group-item">
      <div className="row justify-content-end">
        <div className="col-auto">
          <AddButton action={() => addMetafieldMapping()}
                     errorHandler={defaultErrorHandler}/>
        </div>
      </div>
    </li>
  </ul>;
};

export default MetafieldMappings;